import React, { Component } from 'react';
import { cloneDeep } from 'lodash';
import { Col, Form, Input, Modal, Row, Select } from 'antd';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class PRTypeForm extends Component {
    constructor() {
        super();

        this.state = {};

        this.formRef = React.createRef();
    }

    handleSubmit = () => {
        this.formRef.current.validateFields().then(values => {
            this.props.onSubmit(values);
        });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();
    }

    handleDidMount = (data = {}) => {
        const cloneData = cloneDeep(data);

        this.formRef.current.setFieldsValue(cloneData);

        this.setState({ editMode: !!cloneData.id });
    }

    render() {
        const { onCancel, submitting, visible } = this.props;
        const { editMode } = this.state;

        return (
            <Modal
                title={editMode ? Resources.edit : Resources.add}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={700}>
                <Form ref={this.formRef} layout="vertical">
                    <Row gutter={24}>
                        <Col xs={24} md={16}>
                            <Form.Item name="title" label={Resources.title} rules={Rules.required}>
                                <Input type="text" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={8}>
                            <Form.Item name="type" label={Resources.type} rules={Rules.required}>
                                <Select placeholder={Resources.choose}>
                                    <Select.Option value="color">color</Select.Option>
                                    <Select.Option value="size">size</Select.Option>
                                    <Select.Option value="brand">brand</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={16}>
                            <Form.Item name="color_code" label={Resources.colorCode} >
                                <Input type="text" />
                            </Form.Item>
                        </Col>
                       
                    </Row>
                </Form>
            </Modal>
        );
    }
};

export default PRTypeForm;